<template>
  <FormKit
    type="submit"
    label="Retour"
    @click="goBack"
    prefix-icon="left"
    :style="{ 
      borderColor: '#0275ff',
      borderWidth: '1px',
      borderStyle: 'solid',
      color: '#0275ff',
      backgroundColor: 'white',
      transition: 'background-color 0.3s, color 0.3s',
    }"
    @mouseover="$event.target.style.backgroundColor = '#0275ff'; $event.target.style.color = 'white'"
    @mouseout="$event.target.style.backgroundColor = 'white'; $event.target.style.color = '#0275ff'"
  />
  <div v-if="masterProduct" class="mb-[1.5rem]">
    <h1 class="info-title">Informations du produit parent</h1>
    <div class="info-row">
      <div class="info-column">
        <div>
          <span class="bold-text">Prototype :</span> {{ masterProduct.prototype.value }}
        </div>
        <div>
          <span class="bold-text">Fournisseur :</span> {{ masterProduct.supplier.value }}
        </div>
      </div>
      <div class="info-column">
        <div>
          <span class="bold-text">Nom du produit :</span> {{ masterProduct.properties.productName[0].value }}
        </div>
        <div>
          <span class="bold-text">Nom du produit dans l’admin :</span> {{ masterProduct.properties.adminProductName[0].value }}
        </div>
      </div>
    </div>
  </div>
  <p class="page-title">Déclinaisons du produit</p>
  <FormKit
    type="form"
    @submit="submitHandler"
    #default="{ value }"
    :value="true"
    :actions="false"
    incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
  >
    <FormKit
      id="repeater"
      name="values"
      type="repeater"
      label="Création de déclinaisons"
      #default="{ index }"
      add-label="Ajouter un attribut"
      :min="minNbrAttributes"
      :max="maxNbrAttributes"
      v-model="attributes"
      @change="generateCombinations"
    >
      <div class="row">
        <div class="column">
          <FormKit
            type="select"
            label="Attribut"
            name="attribute"
            validation="required|length:1,50"
            placeholder="Sélectionner une valeur"
            :validation-messages="{
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 50 caractères.',
            }"
            :options="filterAttributesOptions(index)"
            @change="fetchValuesData(index)"
          />
        </div>
        <div class="column">
          <FormKit
            type="taglist"
            label="Valeur"
            name="attributeValue"
            validation="required|length:1,50"
            placeholder="Sélectionner une valeur"
            :validation-messages="{
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 50 caractères.',
            }"
            v-if="attributeValuesOptions[index]"
            :options="attributeValuesOptions[index].length ? attributeValuesOptions[index]:['']"
            :allow-new-values="true"

          />
        </div>
      </div>
    </FormKit>
    <div class="mb-4 mt-8">
      <h2 class="text-lg font-semibold !text-blue-800">Récapitulatif des déclinaisons générées</h2>
    </div>
    <table class="min-w-full mt-5">
      <thead>
      <tr>
        <th class=" font-medium border-b border-gray-200  bg-gray-50 ">
          Attributs
        </th>
        <th class=" font-medium border-b border-gray-200 bg-gray-50 ">
          Valeurs des attributs
        </th>
        <th class=" font-medium border-b border-gray-200 bg-gray-50 ">
          Supprimer cette combinaison
        </th >
          <th class=" font-medium border-b border-gray-200 bg-gray-50 "></th>
      </tr>
      </thead>

      <tbody class="bg-white">
      <tr v-for="(combination , index) in combinationValues" :key="index">
        <td  class="text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap" >
          <ul><li v-for="(attr, indexAttr) in  combination" :key="indexAttr"> {{ mappingAttributes[attr.attribute] }} </li></ul>
        </td>
        <td  class="text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap">
          <ul><li v-for="(attr, indexVal) in  combination" :key="indexVal">{{mappingValues[attr.value] ? mappingValues[attr.value]: attr.value }} </li></ul>
        </td>
        <td class="text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap">
          <Button size="small" icon="pi pi-trash" class="p-button-danger" title="supprimer"
                  @click="combinationValues.splice(index,1)"

          > </Button>
        </td>
          <td class="text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap"><span v-if="checkCombinationAffectedToVariant(combination)">Cette déclinaison existe déjà.</span></td>
      </tr>
      </tbody>
    </table>
    <div class="flex justify-center items-center mt-4">
      <FormKit
        type="submit"
        label="Créer les déclinaisons"
        class="btn"
      />
    </div>
  </FormKit>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch } from "vue";
import ApiService from "@/_services/api.service";
import Button from "primevue/button";
import swal from "@/_helpers/swal";
import { useRoute } from 'vue-router';
import router from "@/router";

let masterProduct = ref(null);
let attributes = ref([]);
let allAttributesOptions = ref([]);
let attributeValuesOptions:any  = ref([]);
let mappingAttributes =ref([]);
let mappingValues = ref([]);
let combinationValues: any = ref([]);
const route = useRoute();
const uuid = ref(route.params.uuid);
let minNbrAttributes = ref(1);
let maxNbrAttributes = ref(5);
const goBack = () => {
  router.push({ name: 'ListProducts' });
};
function filterAttributesOptions(index) {
  let optionsSelected = attributes.value.map((val: any) => {
    return val.attribute;
  })
  return allAttributesOptions.value.filter((option: any) => {
      return optionsSelected.indexOf(option.value) === -1 || optionsSelected.indexOf(option.value) === index
    }
  )
}
async function fetchValuesData(index) {
  const  uuid = attributes.value[index].attribute;
  attributes.value[index].attributeValue = [];
  try {
    const response =  await ApiService.get(`attributes/${uuid}`);
    attributeValuesOptions.value[index] = response.data.data.attributeValues.map(
      (val: any) => {
        mappingValues.value[val.uuid] = val.name ;
        return {
          label: val.name,
          value: val.uuid
        }
      }
    );
  } catch (error) {
    console.error(error);
  }


}
async function fetchAttributes() {
  try {
    const response = await ApiService.get('attributes?itemsPerPage=1000');
    allAttributesOptions.value = response.data.data.map((attr: any) => {
      mappingAttributes.value[attr.uuid] = attr.name
      return { label: attr.name, value: attr.uuid }});

  } catch (error) {
    console.log(error);
  }
}
async function fetchMasterProduct() {
  try {
    const response = await ApiService.get(`master-product/${uuid.value}`);
    masterProduct.value = response.data.data;
    initAttributesData();
  } catch (error) {
    console.error('Error fetching master product:', error);
  }
}

onMounted(() => {
    fetchMasterProduct()
});


function initAttributesData() {
    if (masterProduct?.value?.attributes?.length) {
        maxNbrAttributes = minNbrAttributes = masterProduct?.value?.attributes?.length;
        allAttributesOptions.value = masterProduct.value.attributes.map((attr: any, index: any) => {
            mappingAttributes.value[attr.uuid] = attr.name
            attributes.value[index] = {attribute: attr.uuid, values: []};
            fetchValuesData(index);
            return {label: attr.name, value: attr.uuid}
        });
    } else {
        fetchAttributes();
    }
}

function checkCombinationAffectedToVariant(combination) {
    let valuesUuidsForCombination = combination.map((val: any) => {
        return val.value;
    });
    let attributesValuesForVariants = Object.values(masterProduct?.value?.attributesValues);
    for (const valuesUuidForVariant of attributesValuesForVariants) {
        let exist = valuesUuidForVariant.every(value => valuesUuidsForCombination.includes(value));
        if (exist) {
            return true;
        }
    }
    return false;
}

function submitHandler(data, formNode) {
  let apiData = {
    variantsAttributes: [],
    masterProduct: uuid.value,
  }
  for (const combination of combinationValues.value) {
      if (checkCombinationAffectedToVariant(combination)) {
          continue;
      }
    let variantsAttributes = [];
    for (const attr of combination) {
      let value = attr.value;
      let attributeUuid = attr.attribute;
      variantsAttributes.push({
        attributeUuid: attributeUuid,
        attributeValueUuid: mappingValues.value[value] ? value : '',
        value: mappingValues.value[value] ? mappingValues.value[value] : value
      })
    }
    apiData.variantsAttributes.push({attributes: variantsAttributes})
  }

    if (apiData.variantsAttributes.length == 0) {
        swal.error('Veuillez choisir d’autres déclinaisons.’');
        return;
    }
  return ApiService.post("/multiple-variant-product", apiData)
    .then(({data}) => {
      swal.success("", "Les déclinaisons ont été créées !");
      router.push({
        name: "listProductVariants",
        params: {
          uuid: uuid.value,
        },
      })
    })
    .catch(({response}) => {
      console.log(response)
    });

}


function generateCombinations(): void {

  combinationValues.value = [];
  let attributesValuesData = [];
  for (const element of attributes.value) {
    let data = [];
    if (element.attributeValue) {
      for (const value of element.attributeValue) {
        data.push({attribute: element.attribute, value: value})
      }
    }

    attributesValuesData.push(data);
  }

  const result: any[][] = [[]];

  for (const subArray of attributesValuesData) {
    const newCombinations: any[][] = [];

    for (const combination of result) {
      for (const element of subArray) {
        newCombinations.push([...combination, element]);
      }
    }

    result.length = 0;
    result.push(...newCombinations);
  }
  combinationValues.value = result;
}



watch(
  attributes,
  (value) => {
    generateCombinations();

  })


</script>
<style scoped>
.row {
  display: flex;
}

.column {
  flex: 1;
  margin-right: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
}

.info-column {
  flex: 1;
  padding: 0 10px;
}
.info-title {
  font-size: 20px;
  color: #0A3382;
  margin-bottom: 20px;
  font-weight: bold;
}
.bold-text {
  font-weight: 600;
  color: #0A3382;
}
</style>
